export default "__VITE_ASSET__bfG5kkny__"